export default [
  { code: "en", label: "English", icon: "/img/flags/australia.svg" },
  { code: "zh", label: "简体中文", icon: "/img/flags/china.svg" },
  { code: "ko", label: "한국어", icon: "/img/flags/korea.svg" },
  { code: "vi", label: "Tiếng Việt", icon: "/img/flags/vietnam.svg" }
];
